var _path, _path2, _path3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgHighestSort2 = function SvgHighestSort2(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M0 0H32V32H0z",
    opacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#579FD7",
    d: "M16.125 10.909l-3.516-4.688c-.22-.295-.716-.295-.937 0L8.156 10.91c-.289.385-.014.937.469.937h1.758V22.98c0 .324.262.586.586.586h2.343c.324 0 .579-.262.579-.586V11.846h1.765c.483 0 .758-.553.469-.937z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7D9FF",
    d: "M22.688 20.14h-1.766V9.009c0-.324-.254-.586-.578-.586H18c-.324 0-.586.262-.586.586V20.14h-1.758c-.482 0-.758.553-.469.937l3.516 4.688c.234.312.704.312.938 0l3.515-4.688c.289-.384.014-.937-.468-.937z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHighestSort2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/highest_sort_2.477c5a4d.svg";
export { ForwardRef as ReactComponent };